import React from "react";
import "./ImportanceOfHealth.css";
import clinicaConfig from "../../clinicaConfig.js";
import {
  FaWhatsapp,
  FaHeartbeat,
  FaCalendarCheck,
  FaUserMd,
  FaClipboardCheck,
  FaSearch,
  FaChartLine,
  FaShieldAlt,
  FaAppleAlt,
  FaRunning,
  FaBed,
  FaTint,
  FaStethoscope,
  FaArrowRight
} from 'react-icons/fa';

const Importancia = () => {
  return (
    <div className="importance-page">
      <div className="importance-hero-integrated">
        <div className="hero-text-content">
          <div className="hero-badge">
            <FaHeartbeat /> Saúde e Prevenção
          </div>
          <h1>Por que cuidar da saúde regularmente?</h1>
          <p>
            A prevenção não é apenas sobre evitar doenças, é sobre garantir vitalidade para aproveitar o melhor da vida. 
            Investir em exames de rotina hoje é ganhar tranquilidade e longevidade para o futuro.
          </p>
        </div>
      </div>

      <div className="importance-container-overlap">
        <div className="benefits-grid-highlight">
          <div className="benefit-card-highlight">
            <div className="highlight-icon-box"><FaSearch /></div>
            <h3>Diagnóstico Precoce</h3>
            <p>Identificar alterações no início aumenta drasticamente as chances de cura e simplifica os tratamentos.</p>
          </div>
          
          <div className="benefit-card-highlight">
            <div className="highlight-icon-box"><FaShieldAlt /></div>
            <h3>Proteção Ativa</h3>
            <p>Fortaleça seu organismo e evite surpresas desagradáveis com um acompanhamento preventivo contínuo.</p>
          </div>

          <div className="benefit-card-highlight">
            <div className="highlight-icon-box"><FaChartLine /></div>
            <h3>Controle Real</h3>
            <p>Monitore taxas vitais como colesterol e glicemia, mantendo o equilíbrio do seu corpo sob controle.</p>
          </div>
        </div>

        <div className="content-wrapper">
          <div className="table-section-modern">
            <div className="section-title-wrapper">
              <div className="title-icon"><FaCalendarCheck /></div>
              <h2>Guia de Periodicidade</h2>
              <p>Saiba quando realizar seus exames de acordo com as recomendações médicas gerais.</p>
            </div>
            
            <div className="table-card">
              <table className="modern-table">
                <thead>
                  <tr>
                    <th>Exame / Procedimento</th>
                    <th>Frequência Ideal</th>
                    <th>Foco da Análise</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>Check-up Laboratorial</strong></td>
                    <td>Anual</td>
                    <td>Hemograma, Glicemia, Colesterol, Tioide.</td>
                  </tr>
                  <tr>
                    <td><strong>Avaliação Cardiológica</strong></td>
                    <td>Anual (após 40 anos)</td>
                    <td>Pressão arterial, saúde do coração e circulação.</td>
                  </tr>
                  <tr>
                    <td><strong>Exames de Imagem</strong></td>
                    <td>Conforme indicação</td>
                    <td>Ultrassonografias para análise estrutural de órgãos.</td>
                  </tr>
                  <tr>
                    <td><strong>Preventivos Específicos</strong></td>
                    <td>Anual</td>
                    <td>Saúde da mulher (Ginecológico) e do homem (Urológico).</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="target-audience-section">
            <h2>Atenção Especial</h2>
            <div className="audience-grid">
              <div className="audience-box">
                <FaUserMd className="aud-icon" />
                <div className="aud-info">
                  <h4>Adultos 30+</h4>
                  <span>Monitoramento metabólico essencial.</span>
                </div>
              </div>
              <div className="audience-box">
                <FaClipboardCheck className="aud-icon" />
                <div className="aud-info">
                  <h4>Histórico Familiar</h4>
                  <span>Prevenção de doenças hereditárias.</span>
                </div>
              </div>
              <div className="audience-box">
                <FaStethoscope className="aud-icon" />
                <div className="aud-info">
                  <h4>Sintomáticos</h4>
                  <span>Investigação de dores ou fadiga.</span>
                </div>
              </div>
            </div>
          </div>

          <div className="lifestyle-strip">
            <div className="ls-item"><FaAppleAlt /> Nutrição</div>
            <div className="ls-item"><FaRunning /> Movimento</div>
            <div className="ls-item"><FaBed /> Sono</div>
            <div className="ls-item"><FaTint /> Hidratação</div>
          </div>

          <div className="cta-final-card">
            <div className="cta-content">
              <h2>Sua saúde é sua maior riqueza</h2>
              <p>Não deixe para depois. A {clinicaConfig.nomeClinica} está pronta para cuidar de você.</p>
              <button className="btn-final-wa" onClick={() => window.open(`https://wa.me/${clinicaConfig.whatsapp}`, '_blank')}>
                <FaWhatsapp /> Falar conosco via Whatsapp <FaArrowRight style={{marginLeft: 8, fontSize: 14}}/>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Importancia;